import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';

const SOURCE_CONFIG = {
    'AI Data Collection': { color: 'secondary', icon: <AutoAwesomeOutlinedIcon /> },
    'Data Upload': { color: 'info', icon: <CloudUploadOutlinedIcon /> },
    Questionnaire: { color: 'primary', icon: <FactCheckOutlinedIcon /> }
};

export default function InitialReportInformationGrid({ facts = [], ariaLabel = 'Initial report information' }) {
    if (!facts.length) {
        return <Typography color="text.secondary">No information recorded yet.</Typography>;
    }

    return (
        <Box
            component="dl"
            aria-label={ariaLabel}
            sx={{
                m: 0,
                display: 'grid',
                gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' },
                gap: 1
            }}
        >
            {facts.map((fact) => {
                const source = fact.source || 'Questionnaire';
                const sourceConfig = SOURCE_CONFIG[source] || SOURCE_CONFIG.Questionnaire;
                const value = String(fact.value ?? '').trim();

                return (
                    <Paper
                        component="div"
                        variant="outlined"
                        key={fact.key}
                        sx={{
                            p: 1.25,
                            borderRadius: 1,
                            boxShadow: 'none',
                            minWidth: 0,
                            borderColor: value && value !== '—' ? 'divider' : 'action.disabledBackground'
                        }}
                    >
                        <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="flex-start">
                            <Typography component="dt" sx={{ minWidth: 0, fontSize: 11, lineHeight: 1.3, fontWeight: 800, color: 'text.secondary' }}>
                                {fact.label}
                            </Typography>
                            {fact.recordLabel ? (
                                <Typography variant="caption" sx={{ flexShrink: 0, color: 'text.disabled', fontWeight: 750 }}>
                                    {fact.recordLabel}
                                </Typography>
                            ) : null}
                        </Stack>
                        <Typography
                            component="dd"
                            sx={{
                                m: 0,
                                mt: 0.75,
                                minHeight: 32,
                                color: value && value !== '—' ? 'text.primary' : 'text.disabled',
                                fontSize: 12.5,
                                lineHeight: 1.45,
                                fontWeight: value && value !== '—' ? 650 : 500,
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'anywhere'
                            }}
                        >
                            {value && value !== '—' ? value : 'Not provided'}
                        </Typography>
                        <Chip
                            size="small"
                            variant="outlined"
                            color={sourceConfig.color}
                            icon={sourceConfig.icon}
                            label={source}
                            sx={{ mt: 1, height: 22, fontSize: 10.5, fontWeight: 750 }}
                        />
                    </Paper>
                );
            })}
        </Box>
    );
}